import React, { useContext, useMemo, useState } from "react";
import "./DocumentPreview.css";
import { IconButton } from "@mui/material";
import { Add, Remove, Launch } from '@mui/icons-material';
import * as msg from "utils/constants/messages";
import * as c from "utils/constants/constants";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";

const DocumentPreview = (props) => {
    const { data = {}, documentPreviewUrl = "" } = useContext(DocumentDetailContext);

    const zoomIn = () => {
        var image = document.getElementById("docImage");
        var currWidth = image.clientWidth;
        image.style.width = currWidth + 40 + "px";
        document.getElementById("img-div").style.overflow = "scroll";
    };
    const zoomOut = () => {
        var image = document.getElementById("docImage");
        var currWidth = image.clientWidth;
        image.style.width = currWidth - 40 + "px";
    };

    const getFaxRemovalStatusMessage = (entityDetails, msg) => {
        if (entityDetails?.fax_cover_page_drop?.status === "Completed") {
            return msg.coverpage_completed;
        } else if (entityDetails?.fax_cover_page_drop?.status === "In Progress") {
            return msg.coverpage_inprogress;
        } else if (entityDetails?.fax_cover_page_drop?.status === "Failed") {
            return msg.coverpage_failed;
        } else {
            return null;
        }
    }

    const findClick = (e) => {
        e.preventDefault();
    };

    return <div style={{ width: "50%" }}>
        <div className="title-box-preview">
            <p
                className="sub-title"
                style={{ padding: "10px", textAlign: "left" }}
            >
                Document preview
            </p>
            {data?.Format !== "pdf" && (
                <div className="icon-text">
                    <IconButton onClick={zoomOut} size="large">
                        <Remove className="icon-action-edit" fontSize="small" />
                    </IconButton>
                    <p>Zoom</p>
                    <IconButton onClick={zoomIn} size="large">
                        <Add className="icon-action-edit" fontSize="small" />
                    </IconButton>
                </div>
            )}
        </div>
        {data?.Entity_Details?.fax_cover_page_drop?.hasOwnProperty('status') ?
            <div className={data?.Entity_Details?.fax_cover_page_drop?.status == "Completed" ? "fax_warning_success_msg" : "fax_warning_process_msg"}>
                <div>{getFaxRemovalStatusMessage(data?.Entity_Details, msg)}</div>
            </div> : null}
        {documentPreviewUrl && (
            <div
                className={
                    data?.Format === "pdf"
                        ? "img-preview-pdf"
                        : "img-preview"
                }
                id="img-div"
                style={{padding: "10px"}}
            >
                <div style={{ position: "relative" }}>
                    {data?.Format === "pdf" ? (
                        <iframe
                            id="docImage"
                            style={{ width: "100%", height: "100vh", pointerEvents: "auto !important" }}
                            src={documentPreviewUrl}
                            //onContextMenu={(event) => this.findClick(event)}
                            alt="doc image"
                        />
                    ) : (
                        <img
                            id="docImage"
                            draggable="false"
                            onContextMenu={(event) => findClick(event)}
                            style={{ height: "100vh" }}
                            src={documentPreviewUrl}
                            alt="doc"
                        />
                    )}
                    <div id="highlight-a" className="highlight-ocr"></div>
                </div>
            </div>
        )}
    </div>
}

export default DocumentPreview;
